(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["waterfowl-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  new Swiper('.reviews-swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.reviews-next',
      prevEl: '.reviews-prev'
    },
    breakpoints: {
      768: { 
        slidesPerView: 3,
        spaceBetween: 30
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube-video-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const videos = document.querySelectorAll(".youtube-thumbnail, .play-button");

  videos.forEach(video => {
    video.addEventListener("click", function() {
      const videoId = this.getAttribute("data-video-id");
      if (typeof $.fancybox !== 'undefined') {
        $.fancybox.open({
          src: `https://www.youtube.com/embed/${videoId}?autoplay=1`,
          type: 'iframe',
          opts : {
            iframe : {
              preload : false
            }
          }
        });
      } else {
        console.error("Fancybox is not defined.");
      }
    });
  });

  // Fetch and display video titles
  const videoContainers = document.querySelectorAll(".youtube-grid-item");
  videoContainers.forEach(container => {
    const videoId = container.querySelector('.youtube-thumbnail').getAttribute("data-video-id");
    const titleElement = container.querySelector('.video-title');
    fetchVideoTitle(videoId)
      .then(title => {
        titleElement.innerText = title;
      })
      .catch(error => {
        console.error("Error fetching video title:", error);
      });
  });

  async function fetchVideoTitle(videoId) {
    const response = await fetch(`https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${videoId}&key=AIzaSyDbMKcoTEQ2y8or0nsc7jRdDMcYhRPo4N0`);
    const data = await response.json();
    if (data.items.length > 0) {
      return data.items[0].snippet.title;
    } else {
      throw new Error("Video not found or API key invalid");
    }
  }
});


  } catch(e) { console.error(e); }
})();
})();
